// 서버가 만든 QR SVG 문자열을 그림으로 보인다 — 인쇄에서도 그대로 나오게 data URI 로 싣는다.
export const QrImage = ({ svg, alt, className }: { svg: string; alt: string; className?: string }) => (
  <img alt={alt} className={className} src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`} />
);
